/** Industry feature flags for POS UI. */

import { normalizeBusinessType, type BusinessTypeValue } from './businessTypes';

const HIDE_BRAND_MODEL = new Set<BusinessTypeValue>([
  'Groceries & Supermarket',
  'Pharmacy',
  'Bakery & Sweets',
]);

const WEIGHT_BASED_INDUSTRIES = new Set<BusinessTypeValue>([
  'Groceries & Supermarket',
  'Bakery & Sweets',
  'Pharmacy',
]);

export function showBrandModel(businessType?: string | null): boolean {
  if (!businessType) return true;
  return !HIDE_BRAND_MODEL.has(normalizeBusinessType(businessType));
}

/** Serial/IMEI tracking is always optional on items; Mobile sample enables it. */
export function supportsSerials(_businessType?: string | null): boolean {
  return true;
}

export function isGroceryOrPharmacy(businessType?: string | null): boolean {
  const normalized = normalizeBusinessType(businessType);
  return WEIGHT_BASED_INDUSTRIES.has(normalized);
}

export type { BusinessTypeValue };
